import { SAGA_ACTIONS } from "../../../_config";
import { useApiCall } from "../appApiCallHook";
import { apiCaller } from "../functions";

export function useProductsApi() {
    const callApi = useApiCall();

    return {
        addUpdateProduct: apiCaller(callApi, SAGA_ACTIONS.PRODUCTS.ADD_UPDATE_PRODUCT),
        searchProduct: apiCaller(callApi, SAGA_ACTIONS.PRODUCTS.SEARCH_PRODUCT),
        deleteProduct: apiCaller(callApi, SAGA_ACTIONS.PRODUCTS.DELETE_PRODUCT),
        generateSKU: apiCaller(callApi, SAGA_ACTIONS.PRODUCTS.GENERATE_SKU),
        updateInventory: apiCaller(callApi, SAGA_ACTIONS.PRODUCTS.UPDATE_INVENTORY),
        updatePrices: apiCaller(callApi, SAGA_ACTIONS.PRODUCTS.UPDATE_PRICES),
        bulkUpdateProducts: apiCaller(callApi, SAGA_ACTIONS.PRODUCTS.BULK_UPDATE_PRODUCTS),
        changeProductStatus: apiCaller(callApi, SAGA_ACTIONS.PRODUCTS.STATUS_CHANGE),
        nonTaxableProductSearch: apiCaller(callApi, SAGA_ACTIONS.PRODUCTS.NON_TAXABLE_PRODUCT_SEARCH),
        addNonTaxableProduct: apiCaller(callApi, SAGA_ACTIONS.PRODUCTS.ADD_NON_TAXABLE_PRODUCT),
        checkSKUUnique: apiCaller(callApi, SAGA_ACTIONS.PRODUCTS.CHECK_SKU_UNIQUE),
        rearrangeProducts: apiCaller(callApi, SAGA_ACTIONS.PRODUCTS.REARRANGE_PRODUCTS),
        adminPopularProductSearch: apiCaller(callApi, SAGA_ACTIONS.PRODUCTS.ADMIN_POPULAR_PRODUCT_SEARCH),
        rearrangePopularProducts: apiCaller(callApi, SAGA_ACTIONS.PRODUCTS.REARRANGE_POPULAR_PRODUCTS),
    };
}
